import { hasValidPublicUserIdentity, publicUserId } from "./public-user-identity.mjs";

function isRecord(value) {
  return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}

function invalidResponse() {
  const error = new Error("invalid_auth_session_response");
  error.code = "invalid_auth_session_response";
  return error;
}

const CLEARED_ME_KEYS = new Set([
  "ok",
  "user",
  "contactVerificationDeviceCleared",
  "localDataBootstrapRequired",
]);

function hasExactKeys(record, expected) {
  const keys = Object.keys(record);
  return (
    (keys.length === expected.size || keys.length === expected.size - 1) &&
    keys.every((key) => expected.has(key))
  );
}

/**
 * `/me` may upgrade device clearance only when it positively identifies the
 * same user already bound to the token envelope. Keep this an exact response
 * contract so token, pending-challenge, link, and error material can never be
 * interpreted as an ordinary session refresh.
 */
export function readClearedMeResponse(value, expectedUserId) {
  const expected = String(expectedUserId || "").trim();
  const returned = isRecord(value) ? publicUserId(value.user) : "";
  if (
    !isRecord(value) ||
    !hasExactKeys(value, CLEARED_ME_KEYS) ||
    value.ok !== true ||
    value.contactVerificationDeviceCleared !== true ||
    (Object.prototype.hasOwnProperty.call(value, "localDataBootstrapRequired") &&
      typeof value.localDataBootstrapRequired !== "boolean") ||
    !expected ||
    !returned ||
    returned !== expected ||
    !hasValidPublicUserIdentity(value.user)
  ) {
    throw invalidResponse();
  }
  return {
    user: value.user,
    contactVerificationDeviceCleared: true,
    localDataBootstrapRequired: value.localDataBootstrapRequired === true,
  };
}
